import moment from 'moment';

const EXPIRATION_DATE_FORMATS = ['YYYY-MM-DD', 'YYYY/MM/DD', moment.ISO_8601];

const buildLocalNoonDate = (dateValue) => new Date(
  dateValue.year(),
  dateValue.month(),
  dateValue.date(),
  12,
  0,
  0,
  0,
);

export const parseExpirationDateForInput = (expirationValue) => {
  if (!expirationValue || expirationValue === '0000-00-00') {
    return '';
  }

  const utcDateValue = moment.utc(expirationValue, EXPIRATION_DATE_FORMATS, true);
  if (utcDateValue.isValid()) {
    return buildLocalNoonDate(utcDateValue);
  }

  const localDateValue = moment(expirationValue, EXPIRATION_DATE_FORMATS, true);
  if (localDateValue.isValid()) {
    return buildLocalNoonDate(localDateValue);
  }

  return '';
};

export const formatExpirationDateForPayload = (expirationValue) => {
  if (!expirationValue) {
    return expirationValue;
  }

  const parsedExpiration = moment(expirationValue);
  if (!parsedExpiration.isValid()) {
    return '';
  }

  return parsedExpiration.format('YYYY/MM/DD');
};